import Link from 'next/link';
import React from 'react';
import { Button } from '@/components/shadcn/button';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/shadcn/card';

export default function ScoutCard() {
  return (
    <div className="container flex size-full flex-1 items-center justify-center">
      <Card className="w-full max-w-[328px]">
        <CardHeader className="pb-4 ">
          <CardTitle className="text-center text-base leading-normal sm:text-xl">
            Interested in monitoring thousands of global locations?
          </CardTitle>
        </CardHeader>
        <CardContent className="pb-4 text-center text-xs sm:text-base">
          Scout allows you to monitor and track changes at thousands of global
          locations using high-quality imagery.
        </CardContent>
        <CardFooter className="flex justify-center">
          <Link href="/login?redirectTo=/scout" className="w-full">
            <Button className="w-full">Create Account</Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  );
}
